import useAddThemes from './useAddThemes.hook';
import ActionsFooter from '@/shared/StepActionsFooter/StepActionsFooter';
import InputWrapper from '@/shared/InputWrapper/InputWrapper';
import { Alert, Select, Space, Switch } from 'antd';
import ExploreAndPlay from '@/shared/ExploreAndPlay/ExploreAndPlay';
import { Drawer } from '@/shared/Drawers';
import useLibraryUtils from '../../useLibraryUtils.hook';
import ThemeActivitiesSelector from './ThemeActivitiesSelector/ThemeActivitiesSelector';
import { StyledAddThemes } from './AddThemes.styled';
import { Text } from '@/shared/Typography';
import { useMediaQuery } from 'react-responsive';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';

export default function AddThemes({ themes, onClose, onFinish, all }) {
  const { state, actions } = useAddThemes({
    themes,
    onFinish,
  });

  const { allText } = useLibraryUtils();

  const canEdit = themes.length == 1;
  const isPhone = useMediaQuery({
    maxWidth: MediaQueryBreakpoints.sm,
  });

  return (
    <Drawer
      title={
        <span>
          Add{' '}
          {all
            ? allText
            : `${themes.length} theme${themes.length > 1 ? 's' : ''}`}{' '}
          to&nbsp;
          <ExploreAndPlay />
        </span>
      }
      width={isPhone ? '100%' : state.editorActive ? '90%' : ''}
      loading={state.loading}
      onClose={onClose}
      footer={
        <>
          <div className="options">
            {canEdit ? (
              <Space className="pointer">
                <Switch
                  checked={state.editorActive}
                  onChange={actions.setEditorActive}
                />
                <Text
                  onClick={() => actions.setEditorActive(!state.editorActive)}
                >
                  Customize the activities for this theme
                </Text>
              </Space>
            ) : null}
          </div>
          <ActionsFooter
            cancel="Cancel"
            cancelAction={onClose}
            finish="Save"
            disabled={
              !state.selectedClasses.length ||
              (state.editorActive && !state.customEnabledActivities?.length)
            }
            finishAction={actions.save}
            processing={state.processing}
          />
        </>
      }
    >
      <StyledAddThemes>
        <div className="first-row">
          {state.classes.length > 1 ? (
            <InputWrapper
              required={true}
              label="Choose where to add the themes"
            >
              <>
                <Select
                  mode="multiple"
                  options={state.classes.map((clazz) => ({
                    id: clazz.id,
                    name: clazz.name,
                  }))}
                  fieldNames={{
                    label: 'name',
                    value: 'id',
                  }}
                  value={state.selectedClasses.map(
                    (selectedClass) => selectedClass.id
                  )}
                  maxTagCount="responsive"
                  showArrow={true}
                  filterOption={(input, option) =>
                    option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder={`Select one at least to continue`}
                  onSelect={actions.onClassAdded}
                  onDeselect={actions.onClassRemoved}
                ></Select>
                {state.selectedClassesAlreadyAdded.length ? (
                  <Alert
                    description={`This theme is already added to some classes (${state.selectedClassesAlreadyAdded
                      .map(
                        (selectedClassAlreadyAdded) =>
                          selectedClassAlreadyAdded.name
                      )
                      .join(', ')})`}
                  />
                ) : null}
              </>
            </InputWrapper>
          ) : null}
          {state.editorActive && <div className="placeholder"></div>}
        </div>
        {canEdit ? (
          <ThemeActivitiesSelector
            editorActive={state.editorActive}
            setEditorActive={actions.setEditorActive}
            theme={themes[0]}
            onActivitiesSelected={(activities) =>
              actions.onCustomActivitiesSelected(
                activities.map((activity) => activity.id)
              )
            }
          />
        ) : null}
      </StyledAddThemes>
    </Drawer>
  );
}
